import camelize from "global/utils/camelize";
import { funAcortarText } from "global/utils/text";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import ContactIcon from "_+_Portal/assets/images/generico/ConctactIcon";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { SelectUserGlobal } from "_+_Portal/context/Actions/DropDownFamiliares/selectFamiliares";
import { PortalContext } from "_+_Portal/context/Provider";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  ButtonOne,
  ButtonTwo,
  ContainerButtons,
  ContainerSelectFamiliar,
} from "./localStyle";

const SelectFamiliar = ({ pasoSelectFamiliar }) => {
  // -------------------------  useContext ----------------------------
  const {
    grupoFamiliarDispatch,
    selectDropDownDispatch,
    listaFamiliaresState,
  } = useContext(PortalContext);
  const { pasoDispatch } = useContext(AutocheckContext);
  // -------------------------  useContext ----------------------------

  // -------------------------  useState ----------------------------
  const [loading, setLoading] = useState(true);
  // -------------------------  useState ----------------------------

  // -------------------------  constants ----------------------------
  const history = useHistory();
  const misFamiliares = listaFamiliaresState.listaFamiliares.data;
  // -------------------------  constants ----------------------------

  // -------------------------  useEffects ----------------------------

  useEffect(() => {
    const sinFamiliares =
      !Array.isArray(misFamiliares) || misFamiliares.length === 0;
    if (sinFamiliares) {
      handleClickTomarTurno();
    } else {
      // wsGetGrupoFamiliar((success) => {
      //   setLoading(!success);
      // })(grupoFamiliarDispatch);
    }
  }, [grupoFamiliarDispatch]);
  // -------------------------  useEffects ----------------------------

  // -------------------------  funciones ----------------------------
  const handleClickAddFamiliar = () => {
    history.push("/GrupoFamiliar");
  };
  const handleClickTomarTurno = () => {
    selectPaso();
  };
  const handleClickTomarTurnoFamiliar = (familiar) => {
    SelectUserGlobal({ id: familiar.id, paciente: familiar.paciente })(
      selectDropDownDispatch
    );
    selectPaso();
  };

  const selectPaso = () => {
    if (pasoSelectFamiliar === "laboratorio") {
      history.push("/laboratorio");
    } else {
      setPaso(pasoSelectFamiliar ? pasoSelectFamiliar : "NecesitoTurno")(
        pasoDispatch
      );
    }
  };

  // -------------------------  funciones ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {loading ? (
        ""
      ) : (
        <LayoutPasos
          title={pasoSelectFamiliar ? "turno del día" : "necesito turno"}
          subtitle={
            pasoSelectFamiliar
              ? "¿De quién es el turno?"
              : "¿Para quién es el turno?"
          }
        >
          <ContainerSelectFamiliar>
            <ButtonOne onClick={handleClickTomarTurno}>
              <ContactIcon /> PARA MI
            </ButtonOne>

            {!Array.isArray(misFamiliares) || misFamiliares.length === 0 ? (
              ""
            ) : (
              <>
                <span className="title">Para un familiar</span>
                <ContainerButtons className="container-buttons">
                  {Array.isArray(misFamiliares) &&
                  misFamiliares.length > 0 &&
                  !loading
                    ? misFamiliares.map((element, key) => {
                        return (
                          <ButtonTwo
                            key={key}
                            onClick={() =>
                              handleClickTomarTurnoFamiliar(element)
                            }
                          >
                            {funAcortarText(30, camelize(element.nombre))}
                          </ButtonTwo>
                        );
                      })
                    : ""}

                  <ButtonTwo onClick={handleClickAddFamiliar}>
                    {" "}
                    <span className="circle">+</span>Agregar a un familiar
                  </ButtonTwo>
                </ContainerButtons>
              </>
            )}
          </ContainerSelectFamiliar>
        </LayoutPasos>
      )}
    </>
  );
};

export default SelectFamiliar;
